import { createStore } from "zustand-x"
import type { TournamentListItem } from "@/domain/tournament/model/Tournament"

interface AdminTournamentListStoreState {
  tournaments: TournamentListItem[]
  totalCount: number
  currentPage: number
  /** 대회명 검색어 */
  keyword: string
  /** 상태 필터 (빈 값이면 전체) */
  status: string
  isLoaded: boolean
  errorMessage: string
}

function makeInitAdminTournamentListState(): AdminTournamentListStoreState {
  return {
    tournaments: [],
    totalCount: 0,
    currentPage: 1,
    keyword: "",
    status: "",
    isLoaded: false,
    errorMessage: "",
  }
}

const AdminTournamentListStore = createStore<AdminTournamentListStoreState>(
  makeInitAdminTournamentListState(),
  { name: "AdminTournamentListStore" },
)

export { AdminTournamentListStore, makeInitAdminTournamentListState }
export type { AdminTournamentListStoreState }
